import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceHero = ({ service, onBookNow }) => {
  return (
    <div className="relative bg-gradient-to-br from-primary/10 via-white to-accent/5 py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                <Icon name={service?.icon} size={24} color="white" />
              </div>
              <span className="text-sm font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">
                {service?.category}
              </span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-bold text-text-primary leading-tight">
              {service?.title}
            </h1>
            
            <p className="text-lg text-text-secondary leading-relaxed">
              {service?.description}
            </p>
            
            <div className="flex flex-wrap items-center gap-6">
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={20} color="var(--color-accent)" />
                <span className="text-text-secondary">
                  <span className="font-medium text-text-primary">{service?.duration}</span> duration
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="DollarSign" size={20} color="var(--color-accent)" />
                <span className="text-text-secondary">
                  Starting at <span className="font-bold text-text-primary text-lg">${service?.startingPrice}</span>
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={20} color="var(--color-accent)" />
                <span className="text-text-secondary">
                  <span className="font-medium text-text-primary">Insured</span> & Bonded
                </span>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                onClick={onBookNow}
                iconName="Calendar"
                iconPosition="left"
                className="flex-1 sm:flex-none"
              >
                Book Now
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Phone"
                iconPosition="left"
                className="flex-1 sm:flex-none"
              >
                Call (555) 123-4567
              </Button>
            </div>
            
            {/* Trust Indicators */}
            <div className="flex items-center space-x-6 pt-4">
              <div className="flex items-center space-x-2">
                <div className="flex">
                  {[...Array(5)]?.map((_, i) => (
                    <Icon key={i} name="Star" size={16} color="var(--color-warning)" />
                  ))}
                </div>
                <span className="text-sm text-text-secondary">4.9/5 (2,847 reviews)</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={16} color="var(--color-accent)" />
                <span className="text-sm text-text-secondary">50,000+ happy customers</span>
              </div>
            </div>
          </div>
          
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-elevation-4">
              <Image
                src={service?.heroImage}
                alt={service?.title}
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-elevation-3 p-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name="CheckCircle" size={24} color="var(--color-success)" />
                </div>
                <div>
                  <div className="text-lg font-bold text-text-primary">99.8%</div>
                  <div className="text-sm text-text-secondary">Satisfaction Rate</div>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-6 -right-6 bg-white rounded-xl shadow-elevation-3 p-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Award" size={24} color="var(--color-primary)" />
                </div>
                <div>
                  <div className="text-lg font-bold text-text-primary">Licensed</div>
                  <div className="text-sm text-text-secondary">& Certified</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHero;